import * as React from 'react';

import {useLoaderData, useNavigate} from 'react-router-dom';
import {useMessage} from '../context/MessageProvider';
import {useAuth} from '../context/AuthProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import FormTextField from '../components/form/FormTextField';
import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormButton from '../components/form/FormButton';
import FormDatePicker from '../components/form/FormDatePicker';

import Header from "../components/Header";
import Subheader from "../components/Subheader";

import { getAnimal, saveAnimal } from '../models/animals';
import GoBack from '../components/GoBack';

import { useConnectivity } from '../context/ConnectivityProvider';


export async function loader({ params }) {
    console.log("loader params", params);
    if (!params.animalId) throw new Error("Need to pick a defined animal first");

    //const animals = await listAnimals();
    const animal = await getAnimal(params.animalId);
    return {animal};
}

const AnimalDeathDepartureFormPage = () => {

    const {setSuccess, setError} = useMessage();
    const {facilityId} = useAuth();
    const {isOnline} = useConnectivity();
    const navigate = useNavigate();

    const {animal} = useLoaderData(); 



    const handleDeparture = async (data) => {
        try {
            console.log("death", data);

            const tempAnimal = {...animal,departed_on: data.departed_on, additional_information_about_departure: data.additional_information_about_departure};

            const saveResult = await saveAnimal(tempAnimal,facilityId,isOnline);
            console.log("save result", saveResult);

            setSuccess("Saved Departure Information");
        } catch (error) {
            console.error(error);
            setError(error.message);
        }
    };


    const handleDeath = async (data) => {
        try {
            console.log("death", data);

            const tempAnimal = {...animal,died_on: data.died_on};

            const saveResult = await saveAnimal(tempAnimal,facilityId,isOnline);
            console.log("save result", saveResult);


            setSuccess("Saved Death Of Animal");
        } catch (error) {
            console.error(error);
            setError(error.message);
        }
    };



    const departureMethods = useForm({ defaultValues: { departed_on: animal.departed_on || null, additional_information_about_departure: animal.additional_information_about_departure || '' } });
    const deathMethods = useForm({ defaultValues: { died_on: animal.died_on || null } });

    return (

        <Container component="main" maxWidth="sm">
            <GoBack onClick={()=>navigate(`/animals/${animal.id}`)} />
            <Header label="Death/Departure" />

            <Subheader label={animal.name} />

            <Subheader label="Departure From Facility" />

            <FormProvider {...departureMethods}>
                <Form onSubmit={departureMethods.handleSubmit(handleDeparture)}>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
                            <FormDatePicker name="departed_on" label="Date of Departure" required/>
                        </Grid>
                        <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
                            <FormTextField name="additional_information_about_departure" label="Departure Notes"/>
                        </Grid>
                        <Grid xs={2} display="flex" justifyContent="center" alignItems="center">
                            <FormButton>Submit</FormButton>
                        </Grid>
                    </Grid>
                </Form>
            </FormProvider>


            <Subheader label="Death Of Animal" />

            <FormProvider {...deathMethods}>
                <Form onSubmit={deathMethods.handleSubmit(handleDeath)}>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
                            <FormDatePicker name="died_on" label="Died On" required/>
                        </Grid>
                        <Grid xs={2} display="flex" justifyContent="center" alignItems="center">
                            <FormButton>Submit</FormButton>
                        </Grid>
                    </Grid>
                </Form>
            </FormProvider>

        </Container>
    )
}
export default AnimalDeathDepartureFormPage;